"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DrawerBody: function() {
        return _index.DrawerBody;
    },
    drawerBodyClassNames: function() {
        return _index.drawerBodyClassNames;
    },
    renderDrawerBody_unstable: function() {
        return _index.renderDrawerBody_unstable;
    },
    useDrawerBodyStyles_unstable: function() {
        return _index.useDrawerBodyStyles_unstable;
    },
    useDrawerBody_unstable: function() {
        return _index.useDrawerBody_unstable;
    }
});
const _index = require("./components/DrawerBody/index");
